// extracted by mini-css-extract-plugin
export default {"container":"styles_container__LxtFZ","image":"styles_image__BdE-+","cards":"styles_cards__17DH-","card":"styles_card__pLtkX"};